import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SectionHeadingProps {
    eyebrow?: ReactNode
    title: ReactNode
    text?: ReactNode
    align?: 'left' | 'center'
    as?: 'h1' | 'h2'
    className?: string
}

export const SectionHeading: FC<SectionHeadingProps> = ({
    eyebrow,
    title,
    text,
    align = 'left',
    as: Heading = 'h2',
    className
}): ReactNode => {
    return (
        <div className={cn(align === 'center' && 'mx-auto text-center', 'max-w-2xl', className)}>
            {eyebrow && (
                <p className={cn('flex items-center gap-3 text-xs font-semibold tracking-[0.2em] text-clay uppercase', align === 'center' && 'justify-center')}>
                    <span aria-hidden='true' className='h-px w-8 bg-gold' />
                    {eyebrow}
                </p>
            )}

            <Heading
                className={cn(
                    'mt-4 font-heading font-semibold tracking-tight text-balance text-ink',
                    Heading === 'h1' ? 'text-4xl leading-[1.08] md:text-6xl' : 'text-3xl leading-tight md:text-[2.75rem]'
                )}
            >
                {title}
            </Heading>

            {text && (
                <p className='mt-5 text-lg leading-relaxed text-pretty text-umber'>
                    {text}
                </p>
            )}
        </div>
    )
}
